/**
 * @generated SignedSource<<583bcf0c316a1f418fcac864b6277acb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NewEvent = {
  acl: ReadonlyArray<AclItem>;
  creators: ReadonlyArray<string>;
  description?: string | null | undefined;
  opencastId: any;
  seriesId?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type UploadCreatePlaceholderMutation$variables = {
  event: NewEvent;
};
export type UploadCreatePlaceholderMutation$data = {
  readonly createPlaceholderEvent: {
    readonly id: string;
  };
};
export type UploadCreatePlaceholderMutation = {
  response: UploadCreatePlaceholderMutation$data;
  variables: UploadCreatePlaceholderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "event"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      }
    ],
    "concreteType": "AuthorizedEvent",
    "kind": "LinkedField",
    "name": "createPlaceholderEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadCreatePlaceholderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadCreatePlaceholderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8026570694fa58430fd748c33f53bbd9",
    "id": null,
    "metadata": {},
    "name": "UploadCreatePlaceholderMutation",
    "operationKind": "mutation",
    "text": "mutation UploadCreatePlaceholderMutation(\n  $event: NewEvent!\n) {\n  createPlaceholderEvent(event: $event) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "86db0852516c2ce9e4bca135b29b7963";

export default node;
